import { Spin } from 'antd';

export function LoadingFallback() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        minHeight: 300,
        width: '100%',
      }}
    >
      <Spin size="large" />
    </div>
  );
}
